
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { RiDeleteBin6Fill, RiLockPasswordFill } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import AddButton from "../../Components/CommonComponent/Button/AddButton";
import DeleteDataModal from "../../Components/CommonComponent/Modals/DeleteDataModal";
import Pagination, { usePagination } from "../../Components/CommonComponent/Pgination/pagination";
import CreateManager from "./CreateManager";
import ChangePasswordForm from "./ChangePassword";
import { useTranslation } from "react-i18next";
import { IoArrowUndoSharp } from "react-icons/io5";
import { NavLink } from "react-router";
import api from "../../services/api";
import { CommonContext } from "../../App";
import LoadingSpinner from "../../Components/CommonComponent/loadingSpiner/LoadingSpinner";


export default function ManagerTable() {
  const {t}=useTranslation();
  const [managers, setManagers] = useState({ allData: [], pagination: { totalRecords: 0 } });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedManager, setSelectedManager] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
const [selectedManagerForPassword, setSelectedManagerForPassword] = useState(null);
 const {branchId,userData}=useContext(CommonContext)
//  console.log(userData)
 const rightsOptions = [
  { name: "Dashboard", nameValue: "dashboard" }, 
  { name: "Day Book", nameValue: "day_book" }, 
  { name: "Entry", nameValue: "entry" }, 
  { name: "Account Books", nameValue: "account_book" }, 
  { name: "Inventory Books", nameValue: "inventory_book" }, 
  { name: "Reports", nameValue: "reports" }, 
  { name: "Create Manager (Setting)", nameValue: "create_manager" }
];
const getRightNames = (rights) => {
  if (!rights || rights.length === 0) return "-";

  return rights
    .map((r) => {
      const match = rightsOptions.find((opt) => opt.nameValue === r);
      return match ? match.name : r;
    })
    .join(", ");
};

  const {
    currentPage,
    itemsPerPage,
    handlePageChange,
    handleItemsPerPageChange,
    getPaginatedData,
  } = usePagination(10);

   const adminId=userData?.user?.id ;      
   const managerId=userData?.user?.admin_id || userData?.user?.adminId  ;      
   const userRole=userData?.user?.role;
  const getDataById=userRole ==="admin"?adminId:managerId;

  const paginationData = getPaginatedData(managers);

  useEffect(() => {
    fetchManagers();
  }, [currentPage, itemsPerPage]);

  const fetchManagers = async () => {
    try {
      setLoadingData(true)
      const res = await api.get(`manager/get-all?page=${currentPage}&limit=${itemsPerPage}&adminId=${getDataById}`);
      if (res.data.success) {
        const { data, pagination } = res.data;
        setManagers({ allData: data, pagination });
      }
    } catch (err) {
      toast.error("Error fetching managers");
    }
    finally{
       setLoadingData(false)
    }
  };

  const handleSave = async (form) => {
    setLoading(true);
    // console.log("handle dsave")
    try {
      const url = selectedManager
        ? `manager/update?id=${selectedManager.id}`
        : `manager/create`;
      const res = await api.post(url, form);
      if (res.data.success) {
        toast.success(selectedManager ? "Manager updated" : "Manager added");
        setIsModalOpen(false);
        setSelectedManager(null);
        fetchManagers();
      } else {
        toast.error(res.data.message || "Save failed");
      }
    } catch (error){
      toast.error(error?.response?.data?.message ||"Server error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (manager) => {
    try {
      const res = await api.post(`manager/delete?id=${manager.id}`,{branchId});
      if (res.data.success) {
        toast.success("Manager deleted");
        fetchManagers();
      }
    } catch {
      toast.error("Failed to delete manager");
    } finally {
      setModalDelete(false);
      setSelectedManager(null);
    }
  };

const handleStatusChange = async (id, status) => {
  // Optimistically update the UI
   setManagers((prev) => ({
    ...prev, // keep pagination intact
    allData: prev.allData.map((m) =>
      m.id === id ? { ...m, status } : m
    ),
  }));

  try {
    await api.post(`manager/update-status?id=${id}`, { status });
    toast.success("Status updated");
    // Optionally refetch to ensure data is correct
    fetchManagers();
  } catch {
    toast.error("Failed to update status");
    // Revert the change if API fails
    setManagers((prev) =>
      prev.map((m) =>
        m.id === id ? { ...m, status: status === "active" ? "inActive" : "active" } : m
      )
    );
  }
};


  return (
    <div className="py-2 flex justify-center">

      <div className="w-full flex flex-col">
        <div>
           <NavLink
            to="/web-setting"
            title="Back to groups table"
            // state={{ typeName: selectedGroupType }}
            className="border inline-block p-1 px-2 text-theme-headerBg rounded hover:bg-theme-headerBg hover:text-theme-color cursor-pointer"
          >
            <IoArrowUndoSharp />
          </NavLink>
        </div>
        {/* Header */}
        <div className="flex justify-between  items-center  py-[2px] bg-theme-headerBg px-2 text-theme-color">
          <div className=" font-medium">{t('manager')} </div>
          <AddButton text={t("add")} onClick={() => setIsModalOpen(true)} />
        </div>

        {/* Table */}
       {loadingData ? (
  <div className="flex justify-center items-center w-full py-12">
    <LoadingSpinner size={70} />
  </div>
) :( managers.allData &&  managers.allData.length === 0 ? (
          <p className="text-center text-gray-500 text-sm italic py-4 ">{t('noDataAvailable')} </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full rounded text-sm capitalize">
              <thead className="">
                <tr className="bg-theme-tableBg text-theme-headerBg border-theme-headerBg rounded-lg">
                  <th className="border-b text-center px-1">{t("srNumber")}</th>
                  <th className="border-b py-[2px] px-1 text-center">{t('name')} </th>
                  <th className="border-b px-1">{t('email')} </th>
                  <th className="border-b px-1">{t('rights')} </th>
                  <th className="border-b px-1">{t('branches')} </th>
                  <th className="border-b px-1 text-center">{t('status')} </th>
                  <th className="border-b px-1 text-center">{t('action')} </th>
                </tr>
              </thead>
              <tbody>
                {paginationData.currentItems.map((m, i) => (
                  <tr key={m.id} className="bg-theme-tableBg hover:bg-theme-tableHoverColor">
                    <td className="border-b px-1 text-center">
                      {(currentPage - 1) * itemsPerPage + i + 1}
                    </td>
                    <td className="border-b px-1 text-center">
                      <strong >
                        {`${m.first_name} ${m.last_name}`}
                      </strong><br />
                      {m.address} - {m.phone}
                      </td>
                    <td className="border-b px-1">{m.email}</td>
                    {/* <td className="border-b px-1">{m.rights?.join(", ")}</td>
                     */}
                     <td className="border-b px-1">{getRightNames(m.rights)}</td>
                   <td className="border-b px-1">
                    {m.branches && m.branches.length > 0
                      ? m.branches.map((b) => b.name).join(", ")
                      : "-"}
                  </td>
               <td className="border-b px-1 text-center">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={m.status === "active"}
                  onChange={() =>
                    handleStatusChange(
                      m.id,
                      m.status === "active" ? "inActive" : "active"
                    )
                  }
                />
                {/* Track */}
                <div
                  className={`w-12 h-5 rounded-full transition-colors duration-300
                  ${m.status === "active" ? "bg-green-500" : "bg-red-500"}`}
                ></div>
                {/* Knob */}
                <div
                  className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow-md transition-transform duration-300
                  ${m.status === "active" ? "translate-x-7" : "translate-x-1"}`}
                ></div>
              </label>
            </td>
 
                    <td className="border-b px-1 text-center">
                    <div className="flex justify-center gap-2">
                      <FaEdit
                        className="cursor-pointer hover:text-theme-btnBg"
                        title="Edit manager"
                        onClick={() => {
                          setSelectedManager(m);
                          setIsModalOpen(true);
                        }}
                      />
                      <RiDeleteBin6Fill
                        className="text-red-700 cursor-pointer hover:text-red-800"
                        title="Delete  manager "
                        onClick={() => {
                          setSelectedManager(m);
                          setModalDelete(true);
                        }}
                      />
                  <RiLockPasswordFill
                        className=" cursor-pointer hover:text-theme-btnBg"
                        title="Change password"
                        onClick={() => {
                          setSelectedManagerForPassword(m);
                          setIsPasswordModalOpen(true);
                        }}
                      />
                    </div>
                  </td>

                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination */}
            <Pagination
              data={managers}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              itemsPerPageOptions={[10, 20, 50]}
              showPageInfo
            />
          </div>
        ))}
      </div>

      {/* Create / Edit Manager Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-[100]">
          <CreateManager
            handleSave={handleSave}
            handleCancel={() => {
              setIsModalOpen(false);
              setSelectedManager(null);
            }}
            loading={loading}
            selectedManager={selectedManager}
          />
        </div>
      )}

      {/* Delete Modal */}
      {modalDelete && (
        <DeleteDataModal
          selectedLedger={selectedManager}
          handleDeleteModalClose={() => {
            setModalDelete(false);
            setSelectedManager(null);
          }}
          handleDeleteLedgerApi={handleDelete}
        />
      )}

{isPasswordModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-[100]">
    <div className="bg-white p-2  rounded-md shadow-lg w-[400px] relative">
      <div className="bg-theme-headerBg rounded-1  text-theme-color ">
        <div className=" font-medium mb-2  py-1 text-center">{t('changePassword')} </div>
      </div>

      {/* Form State */}
      <ChangePasswordForm
        manager={selectedManagerForPassword}
        onClose={() => setIsPasswordModalOpen(false)}
       
      />
    </div>
  </div>
)}


    </div>
  );
}

